import * as ActionType from "./paymentHistory.type";

const initialState = {
  paymentHistory: [],
  totalPaymentHistory: 0,
};

export const paymentHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.GET_PAYMENT_HISTORY:
      return {
        ...state,
        paymentHistory: action.payload.paymentHistory,
        totalPaymentHistory: action.payload.totalPaymentHistory,
      };

    default:
      return state;
  }
};
